const FIELD_LABELS = {
    id: 'ID',
    name: 'Name',
    partner: 'Partner',
    company: 'Company',
    type: 'Type',
    base_url: 'Base URL',
    credentials: 'Credentials',
    is_enabled: 'Status',
    last_synced_at: 'Last synced',
    last_error: 'Last error',
};

export const DEFAULT_CONNECTION_STATS = ['name', 'partner', 'company', 'credentials', 'is_enabled', 'last_error'];

export function labelsToStats(labels = []) {
    const reversed = Object.fromEntries(Object.entries(FIELD_LABELS).map(([key, label]) => [label, key]));
    return labels.map((label) => reversed[label]).filter(Boolean);
}

export function formatCredentials(credentials) {
    if (!credentials || typeof credentials !== 'object') {
        return '';
    }

    return Object.entries(credentials)
        .filter(([, value]) => value != null && value !== '')
        .map(([key, value]) => `${key}: ${value}`)
        .join(', ');
}

export function flattenConnection(connection, stats = DEFAULT_CONNECTION_STATS) {
    const selected = stats.length ? stats : DEFAULT_CONNECTION_STATS;
    const values = {
        id: connection.id,
        name: connection.name || '',
        partner: connection.partner?.name || '',
        company: connection.company?.name || '',
        type: connection.company?.type || '',
        base_url: connection.base_url || '',
        credentials: formatCredentials(connection.credentials),
        is_enabled: connection.is_enabled ? 'active' : 'blocked',
        last_synced_at: connection.last_synced_at || '',
        last_error: connection.last_error || '',
    };

    const row = {};
    selected.forEach((key) => {
        row[FIELD_LABELS[key] || key] = values[key] ?? '';
    });
    row._raw = connection;

    return {key: connection.id, value: row};
}
